import ServerApi from './$server.api'

export default {
    createCredit,
    createInvoice,
    getCredits,
    deleteCredit
}

async function createCredit(data) {
    return await ServerApi.request('post', '/credits', {data})
}

async function createInvoice(data) {
    const timezone = new Date().getTimezoneOffset()/60
    const query = {timezone}
    return await ServerApi.request('post', '/credits/invoices', {data, query})
}

async function getCredits(query) {
    return await ServerApi.request('get', '/credits', {query})
}

async function deleteCredit(creditId) {
    return await ServerApi.request('delete', `/credits/${ creditId }`)
}